export const hoursInDay = 24;

// date formats:
export const yearMonthDayFormat = 'YYYY-MM-DD';
export const monthDayYearFormat = 'MM-DD-YYYY';
export const monthDayYearWithSlashFormat = 'MM/DD/YYYY';
export const hoursMinutesSecondsFormat = 'HH:mm:ss';
export const dayDateFormat = 'ddd, MMM D, YYYY';
export const uiDateFormatFull = 'ddd, MMM D, YYYY [at] h:mmA';
export const uiOnlyDateFormat = 'ddd, MMM D, YYYY';
export const uiDateFormat = 'MMM D, YYYY [at] h:mmA';
export const uiDateFormatShort = 'MMM D, YYYY';
export const dayMonthShort = 'D MMM';
export const timeFormatUi = 'hh:mm A';
export const timeFormatShort = 'h:mma';
export const dashboardColumnDateFormat = 'ddd M/D';
export const dashboardNavDateFormat = 'MMM DD';
export const dayMonthDate = 'ddd, MMM Do';
export const dateWithSlash = 'MM/DD/YY';
export const dayFormat = 'dddd';
export const monthYearFullFormat = 'MMMM, YYYY';
export const monthDayYearFullFormat = 'MMMM DD, YYYY';

// timezones:
export const defaultTimeZone = 'America/New_York'; // -4 or -5
export const easternTimezone = 'America/New_York'; // -4 or -5
export const centralTimezone = 'America/Mexico_City'; // -5 or -6
export const mountainTimezone = 'America/Denver'; // -6 or -7
export const pacificTimezone = 'America/Los_Angeles'; // -7 or -8



// WEBPACK FOOTER //
// ./src/constants/date.js